let cn = {
    TENDERTOTAL: "招标总数",
    WINBIDTOTAL: "中标总数",
    CANBIDTOTAL: "可投标总数",
    NOBIDLIST: "未投标列表",
    BIDEDLIST: "已投标列表"
};
let tw = {
    TENDERTOTAL: "招標總數",
    WINBIDTOTAL: "中標總數",
    CANBIDTOTAL: "可投標總數",
    NOBIDLIST: "未投標列表",
    BIDEDLIST: "已投标列表"
};
let en = {
    TENDERTOTAL: "Total number of tenders",
    WINBIDTOTAL: "Total number of winning bids",
    CANBIDTOTAL: "Total number of bids",
    NOBIDLIST: "No bid list",
    BIDEDLIST: "Bidded List",
}

export {
    cn,
    tw,
    en
}